"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequestLogic = void 0;
const axios_1 = __importDefault(require("axios"));
const lodash_1 = require("lodash");
const qs_1 = require("qs");
const redux_logic_1 = require("redux-logic");
const Alerts_1 = require("../Alerts");
const Localize_1 = require("../Localize");
const Utils_1 = require("../Utils");
const CreateAction_1 = require("./CreateAction");
const Keys_1 = require("./Keys");
const Utils_2 = require("./Utils");
const httpRequest = (config) => (0, axios_1.default)(config);
const createRequestLogic = (id, requestConfig) => (0, redux_logic_1.createLogic)({
    cancelType: (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Cancel, id),
    type: (0, Utils_2.createRequestActionType)(Keys_1.RequestActionType.Load, id),
    process: (process, dispatch, done) => {
        const meta = process.action.meta;
        const { locals } = process.getState();
        const url = meta.url && new URL(meta.url);
        if (locals.code !== Localize_1.AvailableLanguages.De && url) {
            const searchQuery = (0, qs_1.parse)(url.search.substring(1));
            const newSearchQuery = {
                ...searchQuery,
                _locale: locals.code,
            };
            url.search = `?${(0, qs_1.stringify)(newSearchQuery)}`;
            meta.url = url.href;
        }
        httpRequest({ ...requestConfig, ...meta })
            .then(({ config, data, status, statusText }) => {
            dispatch((0, CreateAction_1.receiveRequest)(id, data, {
                status,
                statusText,
                config,
            }));
        })
            .catch((axiosError) => {
            var _a;
            const error = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
            const message = (error &&
                (0, lodash_1.isArray)(error.message) &&
                (0, Utils_2.getStrapiErrorMessages)(error.message)) ||
                (error && error.message) ||
                'Holy cow, something went wrong';
            dispatch((0, CreateAction_1.failRequest)(id, error, meta));
            dispatch(Alerts_1.alertAction.add({
                state: Alerts_1.ToggleType.Show,
                message,
                id: (0, Utils_1.randomHash)(),
                type: Alerts_1.AlertTypes.Danger,
            }));
        })
            .finally(() => done());
    },
});
exports.createRequestLogic = createRequestLogic;
